/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.customers.users.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('SherpaCustomersUsersController', ['$scope', '$state', 'ApiService', 'HelpersService', function($scope, $state, ApiService, HelpersService) {
    $scope.emailLink = '<div class="ui-grid-cell-contents"><a class="clickable" data-ng-click="grid.appScope.getOrders(row)" role="link">{{row.entity.email}}</a></div>';

    $scope.sherpaCustomersUsers = {
      customers: [],
      searchQuery: '',
      searchOrderQuery: '',
      isLoaded: false,
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Customers'
        });
        $scope.sherpaCustomersUsers.getCustomers();
      },
      getCustomers: function() {
        ApiService.customerService.listCustomers().then($scope.sherpaCustomersUsers.success.getCustomers,$scope.sherpaCustomersUsers.error.getCustomers);
      },

      getOrders: function(row) {
        $state.go('application.sherpa.customers.orders', { id: row.entity.id, type: 'visitor' });
      },

      search: function() {
        var searchQuery = $scope.sherpaCustomersUsers.searchQuery;
        var searchOrderQuery = $scope.sherpaCustomersUsers.searchOrderQuery;

        if ((!searchQuery || searchQuery === '') && (!searchOrderQuery || searchOrderQuery === '')){
          ApiService.customerService.listCustomers().then($scope.sherpaCustomersUsers.success.getCustomers,$scope.sherpaCustomersUsers.error.getCustomers);
        } else {
          if (searchOrderQuery && searchOrderQuery.length > 3) {
            ApiService.customerService.getOrdersLike(searchOrderQuery, '').then($scope.sherpaCustomersUsers.success.getOrders,$scope.sherpaCustomersUsers.error.getOrders);
          } else {
            ApiService.customerService.searchCustomers(searchOrderQuery, searchQuery).then($scope.sherpaCustomersUsers.success.getCustomers,$scope.sherpaCustomersUsers.error.getCustomers);
          }
        }

      },
      success: {
        getCustomers: function(response) {
          var self = $scope.sherpaCustomersUsers;
          self.customers = response.data.payload;
          self.isLoaded = true;
        },
        getOrders: function(response) {
          if (response.data.payload && response.data.payload.length == 1) {
            var order = response.data.payload[0];
            $state.go('application.sherpa.customers.orders', { id: order.tenantId, type:'tenant', orderNumber: order.orderNumber });
          }

        }
      },
      error: {
        getCustomers: function(response) {

        },
        getOrders: function(response) {

        }
      }

    };

    $scope.sherpaCustomersUsers.init();

    $scope.gridOptions = {
      multiSelect: false,
      enableRowSelection: false,
      paginate: true,
      showFooter: true,
      pageSize: 50,

      appScopeProvider: {
        getOrders: $scope.sherpaCustomersUsers.getOrders
      },

      columnDefs: [
        {
          field: 'id',
          displayName: 'ID',
          visible: true
        },
        {
          field: 'email',
          displayName: 'email',
          enableSorting: false,
          enableHiding: false,
          onCellNavClick: function(row, col) {
            $scope.sherpaCustomersUsers.getOrders(row);
          },
          cellTemplate: $scope.emailLink,
          sort: {
            direction: 'asc'
          }
        },
        {
          field: 'firstName',
          displayName: 'First Name'
        },
        {
          field: 'lastName',
          displayName: 'Last Name'
        }
      ]
    };
}]);